import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=e3294c0e&scoped=true"
import script from "./VersionInfo.vue?vue&type=script&lang=js"
export * from "./VersionInfo.vue?vue&type=script&lang=js"
import style0 from "./VersionInfo.vue?vue&type=style&index=0&id=e3294c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3294c0e",
  null
  
)

export default component.exports